import Footer from "../ones/Footer";
import ProductsContent from "../ones/ProductsContent";

export default function ProductsLanding() {
	return (
		<>
			<ProductsContent />
			<Footer />
		</>
	);
}
